import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { RecipeElementType } from "./RecipeCard";
import { ReactSVG } from "react-svg";

type CardActionIconProps = Pick<RecipeElementType, "isClickOut" | "recipeId">;

export const CardActionIcon = ({ isClickOut }: CardActionIconProps) => {
  const { getIcon } = useGlobalContext();

  return (
    <ReactSVG
      src={getIcon(isClickOut ? "circleExternalLink" : "circleArrowRight")}
      height={31}
      width={31}
      wrapper="svg"
      aria-hidden
    />
  );
};
